<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='#'>{{translations('navbar.return_management')}}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-return'>{{translations('return.archive_return')}}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{translations('return.new_return_processing')}}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{translations('return.arrival_date')}}</th>
                <td>
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnInfo.arrived_at) || '----------'}}</button>
                  <div id='popover-info06' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return.arrival_date')}}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_arrived' class='form-control input-date'>
                      <input type='time' v-model='time_arrived' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('arrived_at', `${date_arrived} ${time_arrived}`,'info06')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return.return_date')}}</th>
                <td>
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ $invoiceTools.formatDateHours(returnInfo.returned_at) || '----------' }}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return.return_date')}}
                    </div>
                    <div class='popover-body d-flex'>
                      <input type='date' v-model='date_returned' class='form-control input-date'>
                      <input type='time' v-model='time_returned' class='form-control input-time'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('returned_at',`${date_returned} ${time_returned}`,'info01')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return.organization_number')}}</th>
                <td>
                  <button
                    ref='info02'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info02'
                    data-placement='right'
                  >{{ returnInfo.reference_number || '----------'}}</button>
                  <div id='popover-info02' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return.organization_number')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input ref='input-info02' type='text' v-model='tempInfo.reference_number' class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('reference_number',tempInfo.reference_number,'info02')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return.billing_address')}}</th>
                <td>
                  <button
                    ref='info03'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info03'
                    data-placement='right'
                  >{{ returnInfo.bill_to || '----------' }}</button>
                  <div id='popover-info03' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return.billing_address')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="master_bill_to" label="name" value="id" v-model="tempInfo.bill_to_id"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('bill_to_id',tempInfo.bill_to_id,'info03')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return.delivery_address')}}</th>
                <td>
                  <button
                    ref='info04'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info04'
                    data-placement='right'
                  >{{ returnInfo.destination || '----------'}}</button>
                  <div id='popover-info04' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return.delivery_address')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="destinations" label="name" value="id" v-model="tempInfo.destinations_id"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('destinations_id',tempInfo.destinations_id,'info04')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return.warehouse')}}</th>
                <td>
                  <button
                    ref='info05'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info05'
                    data-placement='right'
                  >{{ returnInfo.warehouse || '----------'}}</button>
                  <div id='popover-info05' class='popover popover-x popover-default popover-fit-content'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return.warehouse')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <v-select :options="master_mywarehouses" label="name" value="id" v-model="tempInfo.warehouses_id"></v-select>
                    </div>
                    <div class='popover-footer'>
                      <button
                        @click="updateField('warehouses_id',tempInfo.warehouses_id,'info05')"
                        type='submit'
                        class='btn btn-sm btn-primary'
                      >{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{translations('return.remarks')}}</th>
                <td>
                  <button
                    ref='info07'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info07'
                    data-placement='right'
                  >{{ returnInfo.memo || '----------' }}</button>
                  <div id='popover-info07' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{translations('return.remarks')}}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempInfo.memo" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempInfo.memo, 'info07')">{{translations('common.update')}}</button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class='form-inline'>
            <div class='form-group'>
              <a class='btn btn-link btn-sm text-danger' href='#'>{{translations('common.delete')}}</a>
            </div>
          </div>
          <hr>
          <div>
            <h5 class='mb-3'>Check list</h5>
            <div class='padding-inline-start-5px'>
              <div>◎{{translations('return.best_condition')}}
                <ul class='margin-bottom-10px'>
                  <li>{{translations('return.sealed_item')}}</li>
                </ul>
              </div>
              <div>○{{translations('return.good_condition')}}
                <ul class='margin-bottom-10px'>
                  <li>{{translations('return.unopened_unused')}}</li>
                </ul>
              </div>
              <div>△{{translations('return.usable')}}
                <ul class='margin-bottom-10px'>
                  <li>{{translations('return.functional_item')}}</li>
                </ul>
              </div>
              <div>×{{translations('return.not_usable')}}
                <ul class='margin-bottom-10px'>
                  <li>{{translations('return.immovable_damaged')}}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class='right-container'>
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div v-if="taxIncluded" class="text-danger">{{translations('common.tax_included')}}</div><!-- TAXSTATUS -->
            <div v-else>{{translations('common.tax_excluded')}}</div>
          </div>
          <div class='table-scroll mb-4'>
            <table class='table table-sm table-striped table-1500 table-align-middle'>
              <thead>
                <tr>
                  <th></th>
                  <th>{{translations('return.condition')}}</th>
                  <th>{{translations('return.operation')}}</th>
                  <th>{{translations('return.reason_return')}}</th>
                  <th>{{translations('return.operation_confirmation')}}</th>
                  <th>{{translations('return.verification_results')}}</th>
                  <th>{{translations('return.model_number')}}</th>
                  <th>{{translations('return.tax_classification')}}</th><!-- TAXSTATUS -->
                  <th>{{translations('return.number_item')}}</th>
                  <th class="width-50-px">{{translations('return.unit_price')}}</th>
                  <th class="width-50-px"></th>
                  <th>{{translations('return.original_unit_price')}}</th>
                  <th>{{translations('return.summary')}}</th>
                  <th>{{translations('return.unit_price_total')}}</th>
                  <th>{{translations('return.total_liabilities')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for='(detail, i) in returnDetail'>
                  <tr :key='i'>
                    <td>
                      <button @click="deleteDetail(i)" class='btn-change minus'><i></i></button>
                    </td>
                    <td>{{ getRetrunPropsById(return_statuses, detail.return_status_id, 'name') }}</td>
                    <td></td>
                    <td>{{ getRetrunPropsById(return_reasons, detail.return_reason_id, 'name') || detail.return_reason_name }}</td>
                    <td>
                      <button
                        type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-info0000' + i"
                        data-placement='right'
                      >{{ (detail.return_state_id) ? getRetrunPropsById(return_states, detail.return_state_id, 'name') : '-------------' }}</button>
                      <div :ref="'info0000' + i" :id="'popover-info0000' + i" class='popover popover-default popover-x has-footer'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'>
                          <button class='close' data-dismiss='popover-x'>×</button>{{translations('return.operation_confirmation')}}
                        </div>
                        <div class='popover-body popover-content'>
                          <select v-model="tempDetail[i].return_state_id" class="custom-select">
                            <template  v-for="(state, i) in return_states">
                              <option :key="i" :value="state.id">{{ state.name }}</option>
                            </template>
                          </select>
                        </div>
                        <div class='popover-footer'>
                          <button @click="updateField('return_state_id', tempDetail[i].return_state_id, ('info0000' + i), detail)" type='submit' class='btn btn-sm btn-primary'>更新</button>
                        </div>
                      </div>
                      <div class='popover-x-marker' style='display: none;'></div>
                    </td>
                    <td>
                      <button
                        type='button'
                        class='btn btn-link p-0'
                        data-toggle='popover-x'
                        :data-target="'#popover-info03' + i"
                        data-placement='right'
                      >{{ detail.test_result ? detail.test_result : '-------------' }}</button>
                      <div :ref="'popover-info03' + i" :id="'popover-info03' + i" class='popover popover-default popover-x has-footer'>
                        <div class='arrow'></div>
                        <div class='popover-header popover-title'>
                          <button class='close' data-dismiss='popover-x'>×</button>{{translations('return.verification_results')}}
                        </div>
                        <div class='popover-body popover-content'>
                          <textarea class='form-control' v-model="tempDetail[i].test_result"></textarea>
                        </div>
                        <div class='popover-footer'>
                          <button @click="updateField('test_result', tempDetail[i].test_result, ('info03' + i), detail)" type='submit' class='btn btn-sm btn-primary'>{{translations('common.update')}}</button>
                        </div>
                      </div>
                      <div class='popover-x-marker' style='display: none;'></div>
                    </td>
                    <td>{{ (typeof detail.model === 'number') ? getRetrunPropsById(products, detail.model, 'model') : detail.model }}</td>
                    <td>
                      <select
                       :disabled="false"
                        v-model="detail.taxclass_id"
                        v-validate="'required'"
                        data-vv-name="taxclass_id"
                        data-vv-as="税区分"
                        class="custom-select width-100-px"
                        required
                        @change="onchangeTaxclass"
                      >
                        <option value="1">{{translations('return.taxable_item')}}</option>
                        <option value="2">{{translations('return.not_applicable')}}</option>
                      </select>
                    </td><!-- TAXSTATUS -->
                    <!-- <td class="right" v-if="taxIncluded" colspan="2">{{ toTaxFormat(detail, 'unit_price') }}</td> -->
                    <td class="right">{{ detail.quantity.toLocaleString() }}</td>
                    <td>
                      <div v-if="!taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price" :id="'unit_price' + i" @focus="refresh('unit_price' + i)" @blur="refresh('unit_price' + i)" @input="onChangePrice('unit_price', detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price && detail.unit_price.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                      <div v-if="taxIncluded" class="number-container"><!-- input 含む number-container ブロック -->
                        <input type="text" class="form-control form-control-sm number-input" style="width:6em;" v-model="detail.unit_price_inctax" :id="'unit_price_inctax' + i" @focus="refresh('unit_price_inctax' + i)" @blur="refresh('unit_price_inctax' + i)" @input="onChangePrice('unit_price_inctax', detail)"/><!-- 既存の class に number-input 追記、id focus blur 記入 -->
                        <span class="form-control form-control-sm number-overlap" style="width:6em;">{{ detail.unit_price_inctax && detail.unit_price_inctax.toLocaleString() }}</span><!-- input 同様の class に number-overlap 追記、style も転記 -->
                      </div>
                    </td>
                    <td v-if="Number(detail.taxclass_id) === 1" class="right">
                      ({{ toUnitPriceTaxLabel(detail) }})
                    </td>
                    <td v-else></td>

                    <td class="right">{{ toTaxFormat(detail, 'row_price') }}</td>

                    <td class="right"><input type="text" class="form-control form-control-sm" style="width:10em;" v-model="detail.remarks"/></td>

                    <td class="right">{{ toTaxFormat(detail, 'total_unit_price') }}</td>
                    <td class="right">{{ detail.return_status_id === 1 ? toTaxFormat(detail, 'total_cost') : '' }}</td>
                  </tr>
                </template>
                <tr class='bg-lightgreen'>
                  <td>
                    <button @click="openAddDetailModal()" class='btn-change plus' type='button'><i></i></button>
                    <button ref="openAddDetailModal" hidden="true" class='btn-change plus' type='button' data-toggle='modal' data-target='#NewReturnsModal'><i></i></button>
                  </td>
                  <td></td>
                  <td></td><!-- TAXSTATUS -->
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalUnitPrice, grandTotalUnitPriceIncTax) }}</td>
                  <td class='font-weight-bold right'>{{ displayGrandTotal(grandTotalDebt, grandTotalDebtIncTax) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class='form-inline'>
            <div class='form-group mr-2'>
              <button @click="addReturn()" class='btn btn-sm btn-primary'>{{ translations('common.update') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewReturnsModal
      :returnDetails='returnDetail'
      :returnStatuses="return_statuses"
      :returnReasons="return_reasons"
      :returnStates="return_states"
      :products="products"
      :vat="{taxIncluded:taxIncluded, vatRate:vatRate}"
    />
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import $ from 'jquery'
import { format } from 'date-fns'
import VueElementLoading from 'vue-element-loading'
import NewReturnsModal from '@/components/NewReturnsModal'
import { mapState } from 'vuex'
export default {
  name: 'NewReturn',
  props: {},
  components: {
    VueElementLoading,
    NewReturnsModal
  },
  watch: {
    returnDetail: {
      handler (v) {
        this.tempDetail = v
        v.forEach((d, i) => {
          if (typeof d !== 'undefined') {
            v[i] = this.prepareDetails(d)
          }
        })
        this.calcGrandTotals()
        setTimeout(() => {
          this.popoverButtons()
        }, 1000)
      },
      deep: true
    },
    'tempInfo.bill_to_id' (newId, oldId) {
      if ((newId && oldId) && (newId.id === oldId.id)) return

      this.updateField('destinations_id', '', 'info04')
      this.listDestinations()
    }
  },
  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT
      isLoading: false,
      returnInfo: {},
      returnDetail: [],
      tempInfo: {},
      tempDetail: [],
      destinations: [],
      delivery_destinations: [],
      products: [],
      grandTotalUnitPrice: 0,
      grandTotalUnitPriceIncTax: 0,
      grandTotalDebt: 0,
      grandTotalDebtIncTax: 0,
      date_arrived: format(new Date(), 'yyyy-MM-dd'),
      date_returned: format(new Date(), 'yyyy-MM-dd'),
      time_arrived: format(new Date(), 'HH:mm'),
      time_returned: format(new Date(), 'HH:mm')
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    return_reasons () {
      return this.$store.getters['Return/getReasons']
    },
    return_statuses () {
      const statuses = this.$store.getters['Return/getStatuses']
      return this.translateStatuses(statuses)
    },
    return_states () {
      const states = this.$store.getters['Return/getStates']
      return this.translateStates(states)
    },
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    master_bill_to () {
      return this.$store.getters['Master/getBillToNewreturn']
    }
  },
  created () {
    this.$store.dispatch('Return/checkReasons')
    this.$store.dispatch('Return/checkStatuses')
    this.$store.dispatch('Return/checkStates')
    this.$store.dispatch('Master/checkMywarehouses')
    this.$store.dispatch('Master/checkBillToNewreturn')

    this.setEmptyData()

    this.isLoading = true
    Promise.all([
      this.getVatRate(), // VAT
      this.getSequence()
    ]).finally(() => {
      this.isLoading = false
      this.setReturnDate()
      this.popoverButtons()
    })
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStatuses (statuses) {
      return statuses.map(status => ({
        ...status,
        name: this.translations(`statuses.${status.name}`)
      }))
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(`states.${state.name}`)
      }))
    },
    refresh (id) { // number-container
      var element = document.querySelectorAll("[id='" + id + "']")
      for (var i = 0; i < element.length; i++) {
        let $this = $(element[i])
        $this.val(Number($this.val())) // TO NUMBER
        $this.next().text((+$this.val()).toLocaleString()) // REFRESH
      }
    },
    numbers (index, target) {
      this.returnDetail[index][target] = this.returnDetail[index][target].toString().replace(/[^0-9.-]/g, '')
    },
    getVatRate () { // VAT
      return this.$http.post(this.$api_url.vat_rate).then(response => {
        const result = response.data
        if (result.status === true) {
          this.vatRate = result.vat_rate
        } else {
          this.$toastr.error(this.translations('return.notice_tax_rate'), this.translations('common.error'))
          this.$refs['defaultCheckTax'].disabled = true
        }
      }).catch(error => {
        console.log('NewReturn:getVatRate:catch(error): ', error)
        this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
      }).finally(() => {
        return Promise.resolve()
      })
    },

    toTaxFormat (data, key) {
      const price = data[key] || 0

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        if (key === 'unit_price') {
          data.unit_price = price
          data.unit_price_inctax = price
        }
        return Number(price).toLocaleString()
      }

      const taxIncluded = data.tax_included || this.taxIncluded
      const taxRate = Number(data.tax_rate || this.taxRate)
      const inctax = this.$util.getIncludeTax(price, taxRate)
      if (key === 'unit_price') {
        data.unit_price = price
        data.unit_price_inctax = inctax
      }
      if (!taxIncluded) { // 税込以外
        return `${Number(price).toLocaleString()} (${Number(inctax).toLocaleString()})`
      } else {
        return `${Number(inctax).toLocaleString()} (${Number(price).toLocaleString()})`
      }
    },

    prepareDetails (data) {
      data.total_cost = data.quantity * data.row_price
      data.total_unit_price = data.quantity * data.unit_price

      if (data.taxclass_id && Number(data.taxclass_id) === 2) { // 税区分（1:課税対象, 2:対象外）
        data.total_cost_inctax = data.total_cost
        data.total_unit_price_inctax = data.total_unit_price
      } else {
        data.total_cost_inctax = this.$util.getIncludeTax(data.total_cost, data.tax_rate)
        data.total_unit_price_inctax = this.$util.getIncludeTax(data.total_unit_price, data.tax_rate)
      }

      return data
    },

    calcGrandTotals () {
      this.grandTotalUnitPrice = 0
      this.grandTotalDebt = 0

      this.tempDetail.forEach(v => {
        if (!this.taxIncluded) { // 税抜
          this.grandTotalUnitPrice += Number(v.total_unit_price)
          if (v.return_status_id === 1) {
            this.grandTotalDebt += Number(v.total_cost)
          }
        } else {
          this.grandTotalUnitPriceIncTax += Number(v.total_unit_price_inctax)
          if (v.return_status_id === 1) {
            this.grandTotalDebtIncTax += Number(v.total_cost_inctax)
          }
        }
      })

      if (!this.taxIncluded) { // 税抜
        this.grandTotalUnitPriceIncTax = this.$util.getIncludeTax(this.grandTotalUnitPrice, this.taxRate)
        this.grandTotalDebtIncTax = this.$util.getIncludeTax(this.grandTotalDebt, this.taxRate)
      } else {
        this.grandTotalUnitPrice = this.$util.getExcludeTax(this.grandTotalUnitPriceIncTax, this.taxRate)
        this.grandTotalDebt = this.$util.getExcludeTax(this.grandTotalDebtIncTax, this.taxRate)
      }
    },

    openAddDetailModal () {
      if (!this.tempInfo.bill_to_id) {
        this.$toastr.warning(this.translations('return.warning_choose_billing')) // 仕切り取得のため、必須に
      } else {
        this.isLoading = true
        this.getProducts()
      }
    },
    setEmptyData () {
      this.returnInfo = {}
      this.returnDetail = []
      this.tempInfo = {}
      this.tempDetail = []
      this.warehouses = []
      this.bill_to = []
      this.delivery_destinations = []
      this.products = []
    },

    isNewReturn () {
      return this.$route.name === 'new-return'
    },

    setReturnDate () {
      this.returnInfo.arrived_at = format(new Date(), "yyyy-MM-dd'T'HH:mm")
      this.tempInfo.arrived_at = format(new Date(), "yyyy-MM-dd'T'HH:mm")
    },

    popoverButtons () {
      window.$("button[data-toggle='popover-x']").each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    /**
     * @param field : sales information props
     * @param value : value
     * @param ref   : reference trigger
     */
    updateField (field, value, ref, propToUpdate) {
      let $this = this
      let val = ''
      const rg = /^\s+$/
      if (!value || value === '-' || value === '' || rg.test(value) === true || typeof value === 'undefined') {
        if (field === 'estimated_at') {
          this.$refs[ref].innerText = '--------------'
        } else {
          this.$refs[ref].innerText = '--------------'
        }
        val = ''
      } else if (field === 'returned_at') {
        this.$refs[ref].innerText = format(new Date(value), 'yyyy/MM/dd HH:mm')
        val = format(new Date(value), "yyyy-MM-dd'T'HH:mm")
      } else if (field === 'arrived_at') {
        this.$refs[ref].innerText = format(new Date(value), 'yyyy/MM/dd HH:mm')
        val = format(new Date(value), "yyyy-MM-dd'T'HH:mm")
      } else if (field === 'warehouses_id') {
        this.master_mywarehouses.forEach(v => {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'bill_to_id') {
        this.master_bill_to.forEach(v => {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
            $this.taxIncluded = Number(v.taxstatus) === 2 // 0:未設定(税抜), 1:税抜, 2:税込 // TAXSTATUS
          }
        })
      } else if (field === 'destinations_id') {
        val = 0 // DEFAULT // WARNING: DBがint型のため''ではエラーが発生する場合、該当selectのデフォルト値に0をセットし、比較対象が0件でも0になるよう初期値に0をセット
        this.destinations.forEach(function (v) {
          if (v.id === parseInt(value.id)) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else {
        if (!propToUpdate) {
          this.$refs[ref].innerText = value
          val = value
        }
      }
      if (propToUpdate) {
        propToUpdate[field] = value
      } else {
        this.returnInfo[field] = val
      }
      window.$('#popover-' + ref).popoverX('hide')
    },

    async getReturnDetails (returnId) {
      try {
        let returns = await this.$http.post(this.$api_url.return_details, { return_id: returnId })
        let $data = this.$invoiceTools.prepareResult(returns.data, 'list', 'Return:getReturnDetails')
        if ($data.success === true) {
          this.returnInfo = $data.data.information
          this.returnDetail = $data.data.details
        } else {
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('Return:getReturnDetails:catch(error): ', error)
        this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
      }
    },

    deleteDetail (i) {
      this.returnDetail.splice(i, 1)
    },

    async listDestinations () {
      try {
        let cList = await this.$http.post(
          this.$api_url.destinations_list,
          { clients_id: this.tempInfo.bill_to_id ? this.tempInfo.bill_to_id.id : '' }
        )
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'NewReturn:listDestinations')
        if ($data.success === true) {
          this.destinations = $data.data
        } else {
          this.destinations = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, this.translations('common.error'))
        }
      } catch (error) {
        console.log('NewReturn:listDestinations:catch(error): ', error)
        this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
      }
    },
    getSequence () {
      return this.$http.post(this.$api_url.return_sequence).then(response => {
        const result = response.data
        if (result.status === true) {
          this.tempInfo.reference_number = result.sequence
          this.returnInfo.reference_number = result.sequence
          this.$refs['info02'].innerText = result.sequence
          this.$refs['input-info02'].value = result.sequence
        }
      }).catch(error => {
        console.log('NewReturn:getSequence:catch(error): ', error)
        this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
      }).finally(() => {
        return Promise.resolve()
      })
    },

    async getProducts () {
      try {
        let params = {}
        if (this.tempInfo.bill_to_id) {
          params = {
            bill_to_id: this.tempInfo.bill_to_id.id, // 仕切り取得のため、必須に
            arrived_at: this.tempInfo.arrived_at // 任意
          }
        }
        let products = await this.$http.post(this.$api_url.return_product_list, params)
        let $data = this.$invoiceTools.prepareResult(products.data, 'list', 'NewReturn:getProducts')
        if ($data.success === true) {
          this.products = $data.data
          this.$refs.openAddDetailModal.click() // 成功時にモーダル表示
        } else {
          this.$toastr.error($data.data, this.translations('return.process_fail'))
        }
      } catch (error) {
        console.log('NewReturn:getProducts:catch(error): ', error)
        this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
      } finally {
        this.isLoading = false
      }
    },

    getRetrunPropsById (selection, id, name) {
      let ret = ''
      selection.forEach((val, i) => {
        if (val.id === id) {
          ret = val[name]
        }
      })
      return ret
    },
    // getRetrunPropsByItemNo (selection, itemNo, name) {
    //   let ret = ''
    //   selection.forEach((val, i) => {
    //     if (val.item_no === itemNo) {
    //       ret = val[name]
    //     }
    //   })
    //   return ret
    // },

    async addReturn () {
      try {
        if (!this.returnInfo.returned_at) {
          this.$toastr.warning(this.translations('return.notice_enter_return_date'))
          return
        }

        if (!this.returnInfo.bill_to_id) {
          this.$toastr.warning(this.translations('return.notice_enter_billing_address'))
          return
        }

        if (!this.returnInfo.warehouses_id) {
          this.$toastr.warning(this.translations('return.notice_enter_warehouse'))
          return
        }

        if (this.returnDetail.length < 1) {
          this.$toastr.warning(this.translations('return.notice_enter_details_line'))
          return
        }

        this.isLoading = true
        this.returnInfo.arrived_at = format(new Date(this.returnInfo.arrived_at), "yyyy-MM-dd'T'HH:mm:ss")
        this.returnInfo.returned_at = format(new Date(this.returnInfo.returned_at), "yyyy-MM-dd'T'HH:mm:ss")
        const params = {
          information: this.returnInfo,
          details: this.returnDetail
        }
        console.log(JSON.stringify(params)) // DEBUG
        const response = await this.$http.post(this.$api_url.return_add, params)
        const result = response.data
        if (result.status === true) {
          this.$toastr.success(this.translations('return.notice_save_success'), this.translations('common.success'))
          this.$router.replace('/single-return?return_id=' + result.id)
        } else {
          this.$toastr.error(result.message, this.translations('common.error'))
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        console.log('NewReturn:addReturn:catch(error): ', error)
        this.$toastr.error(this.translations('return.notice_failed'), this.translations('common.error'))
      }
    },
    onchangeTaxclass () {
      this.returnDetail.forEach((detail, i) => {
        if (typeof detail !== 'undefined') {
          this.returnDetail[i] = this.prepareDetails(detail)
        }
      })
      this.calcGrandTotals()
    },

    toUnitPriceTaxLabel (data) {
      const taxIncluded = data.tax_included || this.taxIncluded
      if (taxIncluded) {
        return Number(data.unit_price).toLocaleString()
      } else {
        return Number(data.unit_price_inctax).toLocaleString()
      }
    },

    displayGrandTotal (val, valIncTax) {
      if (!this.taxIncluded) { // 税抜
        return `${Number(val).toLocaleString()} (${Number(valIncTax).toLocaleString()})`
      } else {
        return `${Number(valIncTax).toLocaleString()} (${Number(val).toLocaleString()})`
      }
    },

    onChangePrice (key, detail) {
      const taxRate = Number(detail.tax_rate || this.taxRate)
      detail[key] = detail[key].replace(/[^0-9.-]/g, '')
      if (key === 'unit_price') {
        detail.unit_price_inctax = this.$util.getIncludeTax(detail[key], taxRate)
      } else if (key === 'unit_price_inctax') {
        detail.unit_price = this.$util.getExcludeTax(detail[key], taxRate)
      }
    }
  }
}
</script>

<style scoped>
.input-date {
  width: 140px;
}
</style>
